import { IonImg, IonLabel, IonModal, isPlatform } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import * as constants from "../../../constants";
import { Plugins } from "@capacitor/core";
import { ToastMessage } from "../../../utils/toastMessage";
import { hideMessenger, openIntercomMessanger } from "../../../intercom";
const { Checkout } = Plugins;

export const BookingDetailsBanner: React.FC = (props: any) => {
  const [showContactUs, setShowContactUs] = useState(false);
  const [toast, setToast] = React.useState({
    showToast: false,
    toastMessage: "",
    severity: "",
  });
  const { bookingId, particularBookingDetails = [], bookingStatus = {} } = props;

  const getOrderid = async () => {
    try {
      const ordRes = await props.getAdvancePaymentOrderId(particularBookingDetails[0].bookingId);
      if (!!ordRes && ordRes.status === "SUCCESS") {
        handleRazorpay(
          ordRes.data[0].orderId,
          particularBookingDetails[0].bookingId,
          ordRes.data[0].amount,
        );
      }
    } catch (e: any) {
      setToast({
        showToast: true,
        toastMessage: e.message,
        severity: "warning",
      });
    }
  };

  const handleRazorpay = async (ordId: any, bookingId: any, amount: any) => {
    var options = {
      description: "Autorox",
      image: null,
      currency: "AED",
      key: "rzp_test_QlO86Kqf8WsYlD",
      amount: String(amount * 100),
      name: "autorox",
      order_id: ordId,
      prefill: {
        email: props.email,
        contact: props.primaryPhoneNumber,
        name: props.name,
      },
      theme: { color: "red" },
      // callback_url:
      //   "https://b2c-api-dev.autorox.co:8443/b2c/api/transaction/payment/callback",
      // redirect: false,
      // modal: {
      //   ondismiss: function () {},
      // },
      retry: false,
    };

    await Checkout.open(options)
      .then((sucRes: any) => {
        const { response = {} } = sucRes;
        props.razorpayCallBack(
          true,
          "",
          "",
          "",
          "",
          bookingId,
          response.razorpay_order_id,
          response.razorpay_payment_id,
          response.razorpay_signature,
        );
        props.paymentCb("success");
        if (!props.fromDashboard) {
          props.history.push({
            pathname: "/portal/booking_details",
            state: { idOfBooking: bookingId },
          });
        }
      })
      .catch((failRes: any) => {
        const parsedError = typeof failRes === "string" ? JSON.parse(failRes) : failRes;
        props.razorpayCallBack(
          false,
          parsedError.code + "",
          parsedError.description,
          "",
          "",
          bookingId,
          "",
          "",
          "",
        );
        if (parsedError.description === "Payment Canceled by User") {
          props.paymentCb("cancelled");
        } else {
          props.paymentCb("failed");
        }
      });
  };

  const handleCallUs = () => {
    if (isPlatform("desktop")) {
      setShowContactUs(true);
    } else {
      document.location.href = `tel:${constants.CONTACT_US_MOBILE}`;
    }
  };
  return (
    <>
      {/* <div className="bc_status" style={{ backgroundColor: bookingStatus.banerColor }}>
        <div className="bc_text">
          <IonImg
            src={bookingStatus.statusImg}
            className={
              bookingStatus.statusLabel === "Payment Pending"
                ? "bc_check paymentPendingImg"
                : "bc_check"
            }
          />
          <IonLabel className="bookingCfn_text">{bookingStatus.statusLabel}</IonLabel>
        </div>
        <div className="booking_msg">
          <IonLabel className="bc_garage_msg">{bookingStatus.statusSummary1}</IonLabel>
          {bookingStatus.statusSummary2 === "contact us or try again" ? (
            <IonLabel className="bc_garage_msg">
              <span
                onClick={() => {
                  isPlatform("desktop")
                    ? props.history.push("/portal/help-and-support")
                    : setShowContactUs(true);
                }}
                style={{ cursor: "pointer", textDecoration: "underline" }}
              >
                contact us
              </span>{" "}
              or try again
            </IonLabel>
          ) : (
            <IonLabel className="bc_garage_msg">{bookingStatus.statusSummary2}</IonLabel>
          )}
        </div>
        {particularBookingDetails[0].status === "InProgress" ? (
          bookingStatus.statusLabel === "Payment Pending" ? (
            <div
              className="bc_id_parent cursor_pointer_style"
              style={{ paddingLeft: 60, paddingRight: 60 }}
              onClick={() => {
                getOrderid();
              }}
            >
              <IonLabel className="bookingId_text cursonPointer">{constants.PAY_NOW}</IonLabel>
            </div>
          ) : bookingStatus.statusLabel === "Payment Successful" ? (
            <div
              className="bc_id_parent cursor_pointer_style"
              style={{ paddingLeft: 60, paddingRight: 60 }}
              onClick={() => {
                if (window.cordova) {
                  const target = "_blank";
                  const options =
                    "location=no,clearcache=yes,hideurlbar=yes,hidenavigationbuttons=yes,cleardata=yes,toolbarposition=top";
                  // InAppBrowser.create(particularBookingDetails[0].invoiceUrl, target, options);
                  window.open(particularBookingDetails[0].invoiceUrl, target, options);
                } else {
                  window.open(particularBookingDetails[0].invoiceUrl);
                }
              }}
            >
              <IonLabel className="bookingId_text">Invoice</IonLabel>
            </div>
          ) : bookingStatus.statusLabel === "Payment Failed" ||
            bookingStatus.statusLabel === "Payment Cancelled" ? (
            <div
              className="bc_id_parent cursor_pointer_style"
              style={{ paddingLeft: 60, paddingRight: 60 }}
              onClick={() => getOrderid()}
            >
              <IonLabel className="bookingId_text bc_garage_msg">Try Again</IonLabel>
            </div>
          ) : (
            <div className="bc_id_parent">
              <IonLabel className="bookingId_text">{constants.BOOKING_ID}</IonLabel>
              <IonLabel className="bc_id">{bookingId}</IonLabel>
            </div>
          )
        ) : (
          <div
            className="bc_id_parent cursor_pointer_style"
            onClick={() => {
              isPlatform("desktop")
                ? props.history.push("/portal/help-and-support")
                : setShowContactUs(true);
            }}
          >
            <IonLabel className="bookingId_text">{bookingStatus.queries}</IonLabel>
          </div>
        )}
      </div> */}
      <IonModal
        isOpen={showContactUs}
        backdropDismiss={true}
        onDidDismiss={() => setShowContactUs(false)}
        cssClass="confirm_picker-modal"
      >
        <div>
          <div className="contactUs_cont">
            <IonLabel className="contactus_text">{constants.CONTACT_US}</IonLabel>
            <img
              src="/images/close_contactus.svg"
              className="close_popup_img"
              onClick={() => setShowContactUs(false)}
            />
          </div>
          <div className="content_container">
            <div className="textcont">
              <IonLabel className="chat_content">{constants.CLICK_ON_CHAT_OPTIONS}</IonLabel>
            </div>
            {/* chat with us */}
            {/* <div
              className="chat_options"
              onClick={() => openIntercomMessanger()}
            >
              <IonLabel className="chatwithus_text">
                {constants.CHAT_WITH_US}
              </IonLabel>
              <img src="/images/chatWithUs.svg" className="chatwithus_img" />
            </div> */}
            <div className="textcont">
              <IonLabel className="chat_content">{constants.MAKE_CALL_TO_CUS}</IonLabel>
            </div>
            <div
              className="callus_options"
              onClick={() => {
                handleCallUs();
                // hideMessenger(); // ! uncomment this to hide intercom messenger
              }}
            >
              <IonLabel className="chatwithus_text">{constants.CALL_US}</IonLabel>
              <img src="/images/Vector.svg" className="chatwithus_img" />
            </div>
          </div>
        </div>
      </IonModal>
      <ToastMessage
        showToast={toast.showToast}
        ToastMessage={toast.toastMessage}
        severity={toast.severity}
        onDidDismiss={() => {
          setToast({
            showToast: false,
            toastMessage: "",
            severity: "",
          });
        }}
      />
    </>
  );
};
export default BookingDetailsBanner;
